import { Container } from "@mui/material";
import styles from "./HomeFaculty.module.scss";
import { getAllAuthorExplore } from "Explore/Services/Author";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import HomeFacultyCard from "./HomeFacultyCard";

const HomeFaculty = () => {
  const [data, setData] = useState({
    data: Array.from({ length: 16 }),
    isLoading: true,
  });

  useEffect(() => {
    getAllAuthorExplore(0, 16, (res) => {
      setData({
        data: res.results,
        isLoading: false,
      });
    });
  }, []);

  return (
    <div className={styles["home-faculty"]}>
      <Container maxWidth="lg" className={styles["home-faculty--title"]}>
        <span>
          Discover our&nbsp;
          <a href={`/explore/faculty`}>expert network</a>
          &nbsp;and potential collaborators.
        </span>
      </Container>

      <div className={styles["home-faculty--swiper__container"]}>
        {data.data.length > 0 && (
          <>
            {Array.from({ length: 2 }).map((_, i) => (
              <Swiper
                key={i}
                spaceBetween={80}
                loop
                allowTouchMove={false}
                autoplay={{
                  delay: 0,
                  reverseDirection: i % 2 === 1,
                  disableOnInteraction: false,
                }}
                slidesPerView="auto"
                speed={i === 0 ? 8000 : 12000}
                modules={[Autoplay]}
                className={styles["home-faculty--swiper"]}
              >
                {data.data
                  .slice(
                    (i * data.data.length) / 2,
                    ((i + 1) * data.data.length) / 2
                  )
                  .map((item, index) => (
                    <SwiperSlide
                      key={index}
                      className={styles["home-faculty--swiper--slide"]}
                    >
                      {data.isLoading ? (
                        <Skeleton.Avatar
                          className={
                            styles["home-faculty--swiper__item--avatar"]
                          }
                          active
                          shape="square"
                        />
                      ) : (
                        <HomeFacultyCard data={item} />
                      )}
                    </SwiperSlide>
                  ))}
              </Swiper>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default HomeFaculty;
